export const SET_STREET = (state, value) => {
  state.street = value
}

export const SET_POSTALCODE = (state, value) => {
  state.postalCode = value
}

export const SET_TOWN = (state, value) => {
  state.town = value
}

export const SET_CITY = (state, value) => {
  state.city = value
}

export const SET_COUNTRY = (state, value) => {
  state.country = value
}
